module.exports = require("vue-esign");